// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{box-sizing:border-box;font-family:PingFangSC-Regular}body,html{margin:0}body{font-size:16PX}#renderNaviHId{display:none}html{font-size:8.05153vw}@media (min-width:750px){html{font-size:33.33333PX}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
